import { render, staticRenderFns } from "./PriceDisplay.vue?vue&type=template&id=89710308"
import script from "./PriceDisplay.vue?vue&type=script&lang=ts"
export * from "./PriceDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports